export function normalizeApiBase(raw) {
  return String(raw ?? "").replace(/['"]/g, "").trim();
}

export function isDevApiBase(apiBase) {
  return /dev\.lip-sync\.ai/i.test(normalizeApiBase(apiBase));
}

/** Google Analytics：本地开发与 dev 环境默认关闭 */
export function resolveGaEnabled(env = process.env) {
  const explicit = env.NUXT_PUBLIC_GA_ENABLED?.trim().toLowerCase();
  if (explicit === "false") return false;
  if (explicit === "true") return true;
  if (isDevApiBase(env.NUXT_PUBLIC_API_BASE)) return false;
  if (env.NODE_ENV !== "production") return false;
  return true;
}

/** 阿里云 SLS 埋点：默认开启（含本地开发与 dev） */
export function resolveLogstoreEnabled(env = process.env) {
  const explicit = env.NUXT_PUBLIC_LOGSTORE_ENABLED?.trim().toLowerCase();
  if (explicit === "false") return false;
  return true;
}

/** @deprecated 请使用 resolveLogstoreEnabled */
export function resolveAnalyticsEnabled(env = process.env) {
  return resolveLogstoreEnabled(env);
}

export function isGaEnabled(config) {
  if (config?.public?.gaEnabled === false) return false;
  if (import.meta.dev) return false;
  if (import.meta.client && /dev\.lip-sync\.ai/i.test(window.location.hostname)) {
    return false;
  }
  return true;
}

export function isLogstoreEnabled(config) {
  return config?.public?.logstoreEnabled !== false;
}

/** SLS 埋点开关（非 GA） */
export function isAnalyticsEnabled(config) {
  return isLogstoreEnabled(config);
}
